import axios from "axios";
import { getAllSubCategories} from "./subCategoriesSlices";

export const getSubCategories = () => (dispatch) => {
    axios("/subCategories")
        .then((res) =>dispatch(getAllSubCategories(res.data)))
        .catch((e) => console.log(e));
}